import { Zone } from "@/shared/interfaces";
import { Grid, Typography, Button } from "@mui/material";
import { useRef } from "react";
import { Polygon, Popup as LeafletPopup } from 'react-leaflet';

interface PolygonLayerProps {
  handleClick: (zone: Zone) => void
  zones: Zone[];
  color?: string;
  isLeafletPopup: boolean;
}
const PolygonLayer: React.FC<PolygonLayerProps> = ({ handleClick, zones,
  isLeafletPopup = true,
  color = 'blue' }) => {
  const popupsRef = useRef<{ [key: string]: any }>({});
  const handleButtonClick = (id: string, zone: Zone) => {
    if (popupsRef.current[id]) {
      popupsRef.current[id].remove();
    }
    handleClick(zone)
  }
  return (
    <>
      {zones.map((polygon) => (
        <Polygon
          color={color}
          weight={2}
          opacity={0.65}
          fillColor={color}
          fillOpacity={0.4}
          key={polygon.id_zona}
          positions={polygon.coordenadas_array as any ?? []} //TODO: Validar tipo de dato
        >
          {isLeafletPopup && (
            <LeafletPopup
              ref={(popup) => {
                if (popup) {
                  popupsRef.current[polygon.id_zona!] = popup;
                }
              }}
            >
              <Grid container spacing={1} >
                <Grid item xs={12}>
                  <Typography variant='subtitle2'>Zona: {polygon.nombre}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='subtitle2'>Tecnicos: {polygon.numero_flotas}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => handleButtonClick(polygon.id_zona!, polygon)}
                  >
                    Asignar Zona
                  </Button>
                </Grid>
              </Grid>
            </LeafletPopup>
          )}
        </Polygon>
      ))}
    </>
  );

};

export default PolygonLayer